import { Module } from "vuex";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { CustomFieldsState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";
import { getters } from "./getters";

export const state: CustomFieldsState = getDefaultState();
const namespaced: boolean = true;

export const customFields: Module<CustomFieldsState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
